
export const participantTypeHelpers = {
  store: null,
  /**
   * Gets the id of the first participant type id in the store
   * ETO is assumed to only have one participant type at this point.
   * @param {object} store
   */
  getParticipantTypeId: () => getParticipantTypeId(participantTypeHelpers.store),
}

function getParticipantTypeId(store) {
  const { participantTypes } = store.getState();
  const { participantTypeState } = participantTypes || {};
  const { data: allParticipantTypes } = participantTypeState || {};
  if(allParticipantTypes && allParticipantTypes.length > 0) {
    return allParticipantTypes[0].id;
  }
  else {
    console.error('No pariticipant types found in the store!');
    return null;
  }
}
